export default "__VITE_ASSET__HPGgxIuB__"